import React, { memo, Fragment, Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faClock, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { Navbar } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';
import Carousel from 'react-bootstrap/Carousel';
import LotesComponent from '@logicaldatacr/ld.lotes.web';
import '@logicaldatacr/ld.lotes.web/dist/index.css';

import PickingInt from "./Interfaz/PickingInt.jsx";
import PickingDetalle from "./Interfaz/PickingDetalle.jsx";
import { SiteRutas, ImagenesRutas } from "../../request/RutasConfig";
import {
    Picking_Obtener_Ordenes, Picking_Obtener_Sucursales_Apoyo, Listar_ParametrosGenerales,
    Picking_Obtener_Productos_Orden, Picking_Auditar_Producto_Orden, Picking_Obtener_Estatus_Producto_Orden,
    Picking_Obtener_Sucursales_Orden_Seg_Usuario, Picking_Aplicar_Picking, Picking_Suborden_Esta_Auditada,
    Listar_ParametrosCadena, Exp_Validar_Despacho_Orden_Ecommerce, Picking_Aplicar_Traslado,
    Picking_Orden_Esta_Pendiente, Picking_Suborden_Requiere_Traslado, Picking_Suborden_Esta_Pendiente,
    Picking_Obtener_Intervalo_Recoger_Tienda, Picking_Obtener_Traslado, Picking_Traslado_Fue_Aplicado
} from "../../request/ProcesosRequest";
import { ParametroCallCenter_Detalle } from "../../request/MantenimientosRequest";
import { Obtener_Estado_Active_Directory_Request } from '../../request/ParametroRequest';
import {
    Obtener_Conexion_Lote_Request, Obtener_SubOrden_Detalles_Lote_Request, Agregar_Inventario_Detalles_Lote_Request,
    Agregar_SubOrden_Detalles_Lote_Request, Eliminar_SubOrden_Detalles_Lote_Por_Articulo_Request
} from '../../request/LotesRequest';
import { ObtieneParametroSucursal } from '../../request/ParametroRequest';
import { Obtener_MenuOpciones } from "../../request/MenuRequest";
import { Notificacion } from '../../components/Util/Notificacion/Notificacion';
import ModalSeguridad from '../Seguridad/ModalSeguridad.jsx';
import ModalValidarLotes from '../../components/Body/Lotes/ModalValidarLotes.jsx';

/**
 * Nombres de opciones de menú de Seg_Menu_Opciones_X_Usuario para Aplicar Picking y Aplicar Traslado respectivamente.
 * */
const segMenuOpcionesXUsuario = ["Aplicar Picking", "Aplicar Traslado", "Permite Despachar Lotes Próximos a Vencer"];

const Confirmacion = ({ show, title, onCancel, onOk, preContent, postContent, okButtonLabel, cancelButtonLabel }) => {

    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {preContent && <div className="row"><div className="col">{preContent}</div></div>}
                <hr />
                {postContent && <div className="row"><div className="col">{postContent}</div></div>}
                <div className="row mt-3 justify-content-center">
                    <Button className="col-3 mr-3" variant="secondary" onClick={() => { onCancel() }}>{cancelButtonLabel ? cancelButtonLabel : "NO"}</Button>
                    <Button className="col-3 ml-3" variant="primary" onClick={() => { onOk() }}>{okButtonLabel ? okButtonLabel : "SI"}</Button>
                </div>
            </Modal.Body >
        </Modal>
    )
};

class Picking extends Component {
    state = {
        activoAD: false,
        menuOpciones: [],
        filtro: {
            mostrar: false,
            sucursalFactura: { selected: "none", options: [] },
            sucursalApoyo: { selected: "none", options: [] },
            estadoAuditoria: { selected: 0, options: [{ Id: 0, Nombre: "Pendientes" }, { Id: 1, Nombre: "Aplicadas" }] },
            ordenSucursalFactura: { selected: "none", options: [] }
        },
        fecha_activa: [new Date(), new Date()],
        ordenes: [],
        seleccion: {
            orden: null,
            rangoHoras: "",
            sucursalApoyo: null,
            prepararOrden: false
        },
        modals: {
            confirmacion: { title: "", show: false, data: null, accion: "", accionRealizada: false },
            picking: { title: "Aplicar Picking", show: false, data: null, accion: segMenuOpcionesXUsuario[0], accionRealizada: false },
            traslado: { title: "Aplicar Traslado", show: false, data: null, accion: segMenuOpcionesXUsuario[1], accionRealizada: false },
            loteVence: { title: "Lote Próximo a Vencer", show: false, data: null, accion: segMenuOpcionesXUsuario[2], accionRealizada: false }
        },
        parametrosCadena: [],
        parametrosGenerales: null,
        sucursalAplicaLotes: false,
        intervaloRecogerTienda: null,
        cargando: false,
        conexionLotes: {
            token: '',
            serviceUrl: ''
        },
        lstLotesSubOrden: [],
        showModalValidarLotes: false,
        lotes_validar: [],
        showLotes: false,
        parametrosLotes: {
            empresa_id: 1,
            sucursal_id: 1,
            bodega_id: 1,
            modulo_id: 208,
            menu_id: 0,
            tipo_accion: 'salida',
            cantidad_requerida: 2,
            cantidad_decimales: 3,
            modo_consulta: false
        },
        articuloLotes: {
            Articulo_Id: '',
            Codigo_Principal: '',
            Nombre: '',
            Articulo_Dias_Vence: 0,
            Articulo_Vence: true,
            Decimales: true
        },
        lstLotesArticulo: [],
        validarArticuloDespacho: false
    };

    componentDidMount() {
        let mensajeValidacion = '';

        //  No se definio un call center en parámetros
        if (this.props.callCenter.Id <= 0) {
            mensajeValidacion = 'No se ha seleccionado un call center en los parámetros.';
        }
        //  No se definio sucursal en parámetros
        if (this.props.sucursal.Id <= 0) {
            if (mensajeValidacion.length > 0) {
                mensajeValidacion = 'No se ha seleccionado call center ni sucursal en los parámetros.';
            } else {
                mensajeValidacion = 'No se ha seleccionado una sucursal en los parámetros.';
            }
        }
        this.obtenerEstadoActiveDirectory();
        //  No se definió algún parámetro
        if (mensajeValidacion.length > 0) {
            Notificacion.error(mensajeValidacion);
            this.props.history.replace(SiteRutas.Home);
            return false;
        }

        //verifica la URL de Ecommece
        const parametrosCadena = this.cargarParametrosCadena();
        parametrosCadena.then((response) => {
            if (!response.Url_Servicio_eCommerce || response.Url_Servicio_eCommerce.trim().length == 0) {
                Notificacion.error('No se ha parametrizado la ruta del servicio ecommerce.');
                this.props.history.replace(SiteRutas.Home);
                return false;
            }

            this.setState({ parametrosCadena: response });
        });

        this.cargar_opciones_menu();
        this.cargarParamCallCenter();
        this.cargarParametrosGenerales();

        let sucursal = Object.assign({}, this.props.sucursal);
        let filtro = Object.assign({}, this.state.filtro);
        filtro.sucursalFactura.selected = sucursal.Id;
        filtro.sucursalFactura.options = [{ ...sucursal }];

        this.cargarSucursalesApoyo();

        this.setState({ filtro });
    }

    obtenerEstadoActiveDirectory = async () => {
        const response = await Obtener_Estado_Active_Directory_Request();
        if (response.Exitoso) {
            this.setState({ activoAD: response.Datos });
        }
        else {
            Notificacion.error(response.Mensaje);
        }
    };

    cargar_opciones_menu = async () => {
        try {
            if (this.props.token) {
                let menuId = 0;
                if (this.props.location.state) {
                    menuId = this.props.location.state.menuId;
                }

                let menuOpciones = [];
                if (menuId > 0) {
                    let response = await Obtener_MenuOpciones(this.props.token, menuId);
                    if (response.Exitoso) {
                        menuOpciones = response.Datos;

                        if (!menuOpciones || menuOpciones.length === 0) {
                            throw "Ha ocurrido un error al obtener los datos relacionados a las opciones de menú del usuario.";
                        }
                    }
                    else {
                        Notificacion.error(response.Mensaje);
                        throw "Ha ocurrido un error al obtener los datos relacionados a las opciones de menú del usuario.";
                    }
                }
                this.setState({ menuOpciones });
            }
        } catch (exception) {
            Notificacion.error(exception);
        }
    }

    toggleModal = (modalName, show = null) => {


        if (modalName === 'picking' && show) {

            if (this.state.sucursalAplicaLotes) {

                let lotes_no_validos = [];

                this.state.seleccion.orden.productos.filter(producto => producto.sucursal === this.state.filtro.ordenSucursalFactura.selected).forEach(producto => {
                    if (producto.aplica_lote) {

                        let cantidad_lotes = 0;

                        const lotesArticulo = this.state.lstLotesSubOrden.filter(lote => lote.Articulo_Id === producto.id);
                        if (lotesArticulo && lotesArticulo.length > 0) {
                            cantidad_lotes = lotesArticulo.reduce((a, b) => a + (parseFloat(b['Cantidad'] || 0)), 0);
                        }

                        if (cantidad_lotes !== producto.seleccionPreparar) {
                            lotes_no_validos.push({
                                ...producto,
                                Articulo_Id: producto.id,
                                Articulo_Nombre: producto.nombre,
                                Detalle_Facturar: producto.seleccionPreparar,
                                Cant_Lotes: cantidad_lotes
                            });
                        }
                    }
                });

                if (lotes_no_validos.length > 0) {
                    this.setState({ showModalValidarLotes: true, lotes_validar: lotes_no_validos });
                    return;
                }
            }
        }

        let { modals } = this.state;

        try {

            let opcionPicking = this.state.menuOpciones.filter(opcion => opcion.Nombre === segMenuOpcionesXUsuario[0])[0];
            //  Validar para opcion de Picking es igual a 0 (desactivada)
            if (show && !opcionPicking.Validar && modalName == "picking") {
                modals.picking.show = false;
                modals.picking.accionRealizada = true;
                this.setState({ modals }, () => {
                    this.validar_vencimiento_lotes();
                });

            } else {

                let opcionTraslado = this.state.menuOpciones.filter(opcion => opcion.Nombre === segMenuOpcionesXUsuario[1])[0];
                // Validar para opcion de Traslado es igual a 0 (desactivada)
                if (show && !opcionTraslado.Validar && modalName == "traslado") {
                    modals.traslado.show = false;
                    modals.traslado.accionRealizada = true;
                    this.setState({ modals }, () => {
                        this.trasladoModalActionResult()
                    });

                }
                else {
                    if (modals[modalName]) {
                        modals[modalName].show = show || !modals[modalName].show;
                        this.setState({ modals });
                    }
                }
            }
        } catch (e) {
            Notificacion.error("Ha ocurrido un error al realizar la acción.");
            this.reiniciarAccionesModales();
        }
    }

    validar_vencimiento_lotes = (pUsuario) => {

        const { seleccion, sucursalAplicaLotes, lstLotesSubOrden, menuOpciones } = this.state;
        let { modals } = this.state;

        if (sucursalAplicaLotes && lstLotesSubOrden && lstLotesSubOrden.length > 0) {

            let existe_lote_vencido = lstLotesSubOrden.some(lote => {
                if (lote.Vence) {
                    const fecha_vence = moment(lote.Fecha_Vencimiento);
                    const fecha_actual = moment();
                    const dias_vencer = fecha_vence.diff(fecha_actual, 'days');
                    return dias_vencer < 0;
                }
                else {
                    return false;
                }
            });

            if (existe_lote_vencido) {
                Notificacion.error("No se puede continuar, ya que existen lotes vencidos.");
                return;
            }

            let resultado = menuOpciones.filter(item => item.Nombre === segMenuOpcionesXUsuario[2]);
            if (resultado.length > 0) {
                if (resultado[0].Validar) {

                    let proximo_a_vencer = false;

                    lstLotesSubOrden.every(lote => {
                        if (lote.Vence) {

                            const articulos = seleccion.orden.productos.filter(item => item.id == lote.Articulo_Id);
                            proximo_a_vencer = moment(lote.Fecha_Vencimiento) <= moment().add(articulos[0].dias_vence, 'days');
                            return !proximo_a_vencer;
                        }
                        return true;
                    });

                    if (proximo_a_vencer) {

                        modals.loteVence.show = true;
                        this.setState({ modals });
                        return;
                    }
                }
            }
        }
        modals.loteVence.show = false;
        modals.loteVence.accionRealizada = true;
        this.setState({ modals }, () => {
            this.pickingModalActionResult(pUsuario);
        });
    }

    cargarParametrosCadena = async () => {
        if (this.props.token) {
            const response = await Listar_ParametrosCadena(this.props.token, this.props.empresa.Id, this.props.sucursal.Cadena);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                Notificacion.error(response.Mensaje);
                return {};
            }
        }
    }

    cargarParametrosGenerales = async () => {
        if (this.props.token) {
            const response = await Listar_ParametrosGenerales(this.props.token);
            if (response.Exitoso) {
                this.setState({ parametrosGenerales: response.Datos });
            }
            else {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    cargarParamCallCenter = async () => {
        if (this.props.token) {
            const response = await ParametroCallCenter_Detalle(this.props.token, this.props.empresa.Id, this.props.callCenter.Id);
            if (response) {

                let [fechaIni, fechaFin] = this.state.fecha_activa;
                if (response.ParDiasCalendarizadas && response.ParDiasCalendarizadas > 0) {
                    fechaFin.setDate(fechaFin.getDate() + response.ParDiasCalendarizadas);
                }

                const fecha_ini = moment.utc().year(fechaIni.getFullYear()).month(fechaIni.getMonth()).date(fechaIni.getDate()).startOf('day').toISOString();
                const fecha_fin = moment.utc().year(fechaFin.getFullYear()).month(fechaFin.getMonth()).date(fechaFin.getDate()).endOf('day').toISOString();

                this.setState({
                    cantDiasCalendarizados: response.ParDiasCalendarizadas,
                    permiteTrabajarCalendarizadas: response.ParPermiteCalendarizadas,
                    fecha_activa: [fecha_ini, fecha_fin],
                    validarArticuloDespacho: response.ValidarArticuloDespacho
                });

                this.cargarOrdenes([fecha_ini, fecha_fin], null, this.state.filtro.estadoAuditoria.selected);
            }
        }
    }

    cargar_Conexion_Lote = async () => {
        if (this.props.token) {
            const response = await Obtener_Conexion_Lote_Request(this.props.token);
            if (response.Exitoso) {
                this.setState({
                    conexionLotes: response.Datos
                });
            }
            else {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    cargar_SubOrden_Detalle_Lotes = async (pSuc_Id, pOrden_Id) => {
        if (this.props.token) {
            const response = await Obtener_SubOrden_Detalles_Lote_Request(this.props.token, this.props.empresa.Id, pSuc_Id, this.props.callCenter.Id, pOrden_Id);
            if (response.Exitoso) {
                this.setState({ lstLotesSubOrden: response.Datos });
            }
            else {
                Notificacion.error(response.Mensaje);
                this.setState({ lstLotesSubOrden: [] });
            }
        }
    }

    agregar_Inventario_Detalle_Lotes = async (pSuc_Id, pBodega_Id, pMov_Id, pLstLotes, pUsuario) => {
        if (this.props.token && pLstLotes && pLstLotes.length > 0) {
            const response = await Agregar_Inventario_Detalles_Lote_Request(this.props.token, this.props.empresa.Id, pSuc_Id, pBodega_Id, pMov_Id, pLstLotes, pUsuario);
            if (!response.Exitoso) {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    buscar_parametro_sucursal_aplica_lotes = async (pOrden, pSucursal_Id, pSucursal_Factura_Id) => {
        if (this.props.token) {
            let aplica_lotes = false;

            const response = await ObtieneParametroSucursal(this.props.token, this.props.empresa.Id, pSucursal_Id, 'Aplica_Lotes');
            if (response.Exitoso) {

                aplica_lotes = response.Datos.valor === 'SI';

                if (!aplica_lotes && pSucursal_Factura_Id !== pSucursal_Id) {
                    const responseFactura = await ObtieneParametroSucursal(this.props.token, this.props.empresa.Id, pSucursal_Factura_Id, 'Aplica_Lotes');
                    if (responseFactura.Exitoso) {
                        aplica_lotes = responseFactura.Datos.valor === 'SI';
                    }
                }
            }

            this.setState({ sucursalAplicaLotes: aplica_lotes });

            if (aplica_lotes) {
                this.cargarParametrosGenerales();
                this.cargar_Conexion_Lote();
                this.cargar_SubOrden_Detalle_Lotes(pSucursal_Id, pOrden.Orden_Id);
            }
        }
    }

    actualizarFiltro = async (e) => {
        let filtro = Object.assign({}, this.state.filtro);
        let dates = e.date;
        let seleccion = Object.assign({}, this.state.seleccion);
        let pendiente = false;

        switch (e.target.name) {
            case "ordenSucursalFactura":
                filtro.ordenSucursalFactura.selected = e.target.value;
                seleccion.prepararOrden = false;

                if (seleccion.orden) {
                    pendiente = await Picking_Suborden_Esta_Pendiente(this.props.token, this.props.empresa.Id, filtro.ordenSucursalFactura.selected, this.props.callCenter.Id, seleccion.orden.Orden_Id);
                    seleccion.orden.estatus = (pendiente.Exitoso && pendiente.Datos) ? "pendiente" : "aplicada";
                }

                this.reiniciarAccionesModales();

                this.setState({ filtro, seleccion }, () => this.cargarProductosOrden(this.state.seleccion.orden));
                return;
            case "sucursalFactura":
                filtro.sucursalFactura.selected = e.target.value;
                break;
            case "sucursalApoyo":
                filtro.sucursalApoyo.selected = e.target.value;
                break;
            case "estadoAuditoria":
                filtro.estadoAuditoria.selected = e.target.value;
                break;
            case "filtroFecha":
            case "fecha_activa":
                const [fechaIni, fechaFin] = dates;
                const isDateBeforeToday = (moment(fechaIni).diff(moment(new Date()), 'days') < 0);
                if (!isDateBeforeToday) {

                    if (fechaIni.getFullYear() < 10000 || fechaFin.getFullYear() < 10000) {

                        const fechas = [
                            moment.utc().year(fechaIni.getFullYear()).month(fechaIni.getMonth()).date(fechaIni.getDate()).startOf('day').toDate(),
                            moment.utc().year(fechaFin.getFullYear()).month(fechaFin.getMonth()).date(fechaFin.getDate()).endOf('day').toDate()
                        ];

                        this.setState({ fecha_activa: fechas }, () =>
                            e.target.name !== 'filtroFecha' && this.cargarOrdenes(fechas, filtro.sucursalApoyo.selected == "none" ? null : filtro.sucursalApoyo.selected, filtro.estadoAuditoria.selected)
                        );
                    }
                    else {
                        Notificacion.error("No puede seleccionar una fecha con un año mayor a 9999.");
                    }
                } else {
                    Notificacion.error("No puede seleccionar una fecha anterior al día actual.");
                }
                return;
        }

        this.setState({ filtro });
    }

    alternarFiltro = () => {
        let filtro = Object.assign({}, this.state.filtro);
        filtro.mostrar = !filtro.mostrar;
        this.setState({ filtro });
    }

    setPrepararOrden = (status) => {
        let seleccion = Object.assign({}, this.state.seleccion);
        seleccion.prepararOrden = status;

        if (seleccion.orden.Estatus_id === 'E' && !this.state.permiteTrabajarCalendarizadas) {
            Notificacion.error('No se permite trabajar con órdenes a futuro.');
            return;
        }

        this.setState({ seleccion });
    }

    cargarOrdenes = async (fecha_activa, sucursalApoyo = null, estado = null) => {

        if (this.props.token) {
            let intervaloRecogerTienda = this.state.intervaloRecogerTienda;
            this.setState({ cargando: true, ordenes: [] });
            let ordenes = [];

            if (!estado) {
                estado = this.state.filtro.estadoAuditoria.selected;
            }

            const response = await Picking_Obtener_Ordenes(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, this.props.sucursal.Id, fecha_activa, sucursalApoyo, estado);
            if (response.Exitoso) {
                ordenes = response.Datos;

                //  Cargar intervalo para recoger en tienda
                const iRTResponse = await Picking_Obtener_Intervalo_Recoger_Tienda(this.props.token, this.props.empresa.Id, this.props.sucursal.Id);

                //  No ocurrieron errores en el procedimiento
                if (iRTResponse.Exitoso) {
                    intervaloRecogerTienda = iRTResponse.Datos;
                } else {
                    intervaloRecogerTienda = null;
                    Notificacion.error("Ha ocurrido un error al obtener el intervalo de horas para recoger en tienda.");
                }
            }
            else {
                Notificacion.error(response.Mensaje);
            }

            let sucursalApoyoSeleccionada = null;
            let filtro = Object.assign({}, this.state.filtro);

            if (filtro.sucursalApoyo.selected !== "none") {
                if (filtro.sucursalApoyo.options.length > 0) {
                    sucursalApoyoSeleccionada = filtro.sucursalApoyo.options.filter(sucursal => sucursal.Id == filtro.sucursalApoyo.selected);

                    if (sucursalApoyoSeleccionada.length > 0) {
                        sucursalApoyoSeleccionada = sucursalApoyoSeleccionada[0];
                    }
                }
            }

            this.setState({ ordenes, intervaloRecogerTienda, seleccion: { ...this.state.seleccion, sucursalApoyo: sucursalApoyoSeleccionada } }, () => this.setState({ cargando: false }));
        }
    }

    cargarSucursalesApoyo = async () => {
        if (this.props.token) {
            let filtro = Object.assign([], this.state.filtro);
            const response = await Picking_Obtener_Sucursales_Apoyo(this.props.token, this.props.empresa.Id, this.props.callCenter.Id);
            if (response.Exitoso) {
                if (Array.isArray(response.Datos)) {
                    filtro.sucursalApoyo.options = response.Datos.filter(sucursal => sucursal.Id !== this.props.sucursal.Id).sort(function (a, b) {
                        if (a.Nombre > b.Nombre) {
                            return 1;
                        }
                        if (a.Nombre < b.Nombre) {
                            return -1;
                        }
                        return 0;
                    });
                    this.setState({ filtro });
                }
            }
            else {
                Notificacion.error(response.Mensaje);
                this.setState({ filtro });
            }
        }
    }

    aplicarTraslado = async (autorizado, pUsuario) => {
        this.setState({ cargando: true });

        let aplicado = false;

        let seleccion = Object.assign({}, this.state.seleccion);
        let filtro = Object.assign({}, this.state.filtro);
        //  Si no se ha pasado una orden por parámetro, se utiliza la orden seleccionada
        const ordenId = seleccion.orden.Orden_Id;

        if (autorizado) {

            //  Existe un token para enviar en header de autenticación (API Request)
            if (this.props.token) {


                let modals = Object.assign({}, this.state.modals);

                modals.picking.show = false;
                modals.traslado.show = false;

                this.setState({ modals });

                seleccion.prepararOrden = false;

                this.setState({ seleccion });

                const responseTraslado = await Picking_Aplicar_Traslado(this.props.token, this.props.empresa.Id, filtro.ordenSucursalFactura.selected, ordenId, this.props.callCenter.Id, pUsuario);

                if (responseTraslado.Exitoso && responseTraslado.Datos) {

                    Notificacion.success("Traslado aplicado correctamente.");

                    aplicado = true;
                } else {
                    Notificacion.error(responseTraslado.Mensaje);
                }
            }
        }

        this.setState({ cargando: false })

        return aplicado;
    }

    /**
     * Extraído de Monitor de Sucursales
     * */
    Validar_Despacho_Orden_Ecommerce = async () => {
        let resultado = '';
        let _Valido = true;

        const seleccion = Object.assign({}, this.state.seleccion);
        const filtro = Object.assign({}, this.state.filtro);

        resultado = await Exp_Validar_Despacho_Orden_Ecommerce(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, seleccion.orden.Orden_Id, filtro.ordenSucursalFactura.selected, "[]", true);

        if (!isNaN(resultado)) {
            let _Mens = parseInt(resultado);
            switch (_Mens) {
                case 1:
                    Notificacion.error('Debe elegir la opción de eliminar, porque no hay cantidades para facturar.');
                    _Valido = false;
                    break;
                case 2:
                    Notificacion.error('Existen sucursales de apoyo que aún no han terminado el proceso. Debe esperar o coordinar con ellas para determinar si la venta continúa o se elimina.');
                    _Valido = false;
                    break;
                case 3:
                    Notificacion.success('Las sucursales de apoyo han confirmado cantidades que pueden ser facturadas.');
                    _Valido = true;
                    break;
                case 4:
                    Notificacion.error('Debe elegir la opción eliminar. porque no hay cantidades para facturar.');
                    _Valido = false;
                    break;
                case 5:
                    Notificacion.error('No se puede confirmar la orden porque está incompleta. El cliente eligió solo aceptar el pedido si se factura completo.');
                    _Valido = false;
                    break;
                default:
                    _Valido = true;
                    break;
            }
        } else {
            Notificacion.error('Error: ' + resultado);
            _Valido = false;
        }

        return _Valido;
    }

    aplicarPicking = async (autorizado, pUsuario) => {
        let seleccion = Object.assign({}, this.state.seleccion);
        let filtro = Object.assign({}, this.state.filtro);
        let modals = Object.assign({}, this.state.modals);
        let aplicado = false;
        const ordenId = seleccion.orden.Orden_Id;

        this.setState({ cargando: true });

        //  El usuario ha ingresado credenciales con permisos para realizar esta acción
        if (autorizado) {

            let pendiente = await Picking_Orden_Esta_Pendiente(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, ordenId);

            //  La orden no ha sido procesasda por Picking
            if (pendiente.Exitoso && pendiente.Datos) {
                let valido = await this.Validar_Despacho_Orden_Ecommerce();

                //  La orden actualmente seleccionada cumple con todos los criterios para despachar una orden
                if (valido) {
                    let parametrosCadena = Object.assign({}, this.state.parametrosCadena);

                    //  Existe un token de autenticación para enviar en headers de API Request
                    if (this.props.token) {


                        const res = await Picking_Suborden_Esta_Auditada(this.props.token, ordenId, this.props.empresa.Id, this.props.callCenter.Id, filtro.ordenSucursalFactura.selected);

                        //  Todos los productos de esta orden (incluyendo sucursales de apoyo) han sido auditados
                        if (res.Exitoso && res.Datos) {

                            modals.picking.show = false;
                            modals.traslado.show = false;

                            this.setState({ modals });

                            const response = await Picking_Aplicar_Picking(this.props.token, this.props.empresa.Id, filtro.ordenSucursalFactura.selected, ordenId, this.props.callCenter.Id, parametrosCadena.Url_Servicio_eCommerce, pUsuario);

                            //  Picking se ha aplicado sin errores
                            if (response.Exitoso && response.Datos) {

                                if (seleccion.orden.Orden_Suc_Factura != filtro.ordenSucursalFactura.selected && seleccion.orden.traslado) {

                                    this.agregar_Inventario_Detalle_Lotes(filtro.ordenSucursalFactura.selected, seleccion.orden.mov_bodega_id, seleccion.orden.traslado, this.state.lstLotesSubOrden, pUsuario);
                                }

                                seleccion.prepararOrden = false;
                                seleccion.orden.estatus = "aplicada";

                                this.setState({ seleccion }, () => { Notificacion.success("Picking aplicado correctamente.") });

                                aplicado = true;
                            } else {
                                Notificacion.error(response.Mensaje);
                            }
                        } else {
                            Notificacion.error("No se han auditado todos los artìculos de esta suborden.");
                        }
                    }
                }
            } else {
                Notificacion.error("Esta orden ya ha sido procesada.");

                modals.picking.show = false;
                modals.traslado.show = false;

                seleccion.prepararOrden = false;

                this.setState({ modals, seleccion }, () => this.seleccionarOrden(null));
            }
        }

        this.setState({ cargando: false });

        return aplicado;
    }

    confirmarAuditarProducto = async (sucursalId, productoId, cantidadAuditada, ordenId = null) => {
        this.setState({ cargando: true });

        if (this.props.token) {

            let seleccion = Object.assign({}, this.state.seleccion);

            //  No se ha definido ordenId en parámetros, por lo que se utiliza la orden seleccionada.
            if (!ordenId) {
                ordenId = seleccion.orden.Orden_Id;
            }

            let pendiente = await Picking_Orden_Esta_Pendiente(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, ordenId);

            //  La orden no ha sido procesasda por Picking
            if (pendiente.Exitoso && pendiente.Datos) {

                const responseEstatus = await Picking_Obtener_Estatus_Producto_Orden(this.props.token, this.props.empresa.Id, sucursalId, ordenId, this.props.callCenter.Id, productoId);
                if (responseEstatus.Exitoso) {

                    if (responseEstatus.Datos.Estatus_Picking === 'PE') {
                        this.auditarProducto(sucursalId, productoId, cantidadAuditada, ordenId);
                    }
                    else {

                        const cantidad_previa = responseEstatus.Datos.Detalle_Cantidad_Picking;
                        const usuario_nombre = responseEstatus.Datos.Usuario_Nombre_Picking;
                        const mensaje = usuario_nombre ?
                            `El usuario ${usuario_nombre} auditó el artículo previamente con la cantidad ${cantidad_previa}. ¿Está seguro que desea continuar?`
                            : `El artículo fue auditado previamente con la cantidad ${cantidad_previa}. ¿Está seguro que desea continuar?`;

                        Swal.fire({
                            title: 'Auditar artículo',
                            text: mensaje,
                            showCancelButton: true,
                            confirmButtonText: 'Si',
                            cancelButtonText: 'No'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.auditarProducto(sucursalId, productoId, cantidadAuditada, ordenId);
                            }
                            else {
                                this.setState({ cargando: false });
                            }
                        });
                    }
                } else {
                    Notificacion.error(responseEstatus.Mensaje);
                    this.setState({ cargando: false });
                }
            } else {
                Notificacion.error("Esta orden (#" + ordenId + ") ya ha sido procesada.");

                let modals = Object.assign({}, this.state.modals);
                modals.picking.show = false;
                modals.traslado.show = false;
                seleccion.prepararOrden = false;

                this.setState({ modals, seleccion, cargando: false }, () => this.seleccionarOrden(null));
            }
        }
        else {
            this.setState({ cargando: false });
        }
    };

    auditarProducto = async (sucursalId, productoId, cantidadAuditada, ordenId = null) => {
        const response = await Picking_Auditar_Producto_Orden(this.props.token, this.props.empresa.Id, sucursalId, ordenId, this.props.callCenter.Id, productoId, cantidadAuditada);
        if (response.Exitoso && response.Datos) {
            let seleccion = Object.assign({}, this.state.seleccion);
            seleccion.orden.productos.forEach(x => {
                if (x.id == productoId) {
                    x.auditado = cantidadAuditada;
                    x.estadoAuditoria = "AP";
                    x.todo = (x.solicitado == x.auditado);
                }
            });

            this.setState({ seleccion }, () => Notificacion.success("El artículo ha sido auditado correctamente."));
        } else {
            Notificacion.error(response.Mensaje);
        }

        this.setState({ cargando: false });
    }

    cargarProductosOrden = async (orden) => {
        if (orden) {
            this.setState({ cargando: true })
            if (this.props.token) {
                let seleccion = Object.assign({}, this.state.seleccion);
                let sucursal = this.state.filtro.ordenSucursalFactura.selected;

                if (sucursal === "none") {
                    sucursal = null;
                }

                const trabajarCalendarizadas = this.state.permiteTrabajarCalendarizadas && orden.Estatus_id === 'E';
                sucursal && orden && (orden.Estatus_id === 'O' || trabajarCalendarizadas) && this.buscar_parametro_sucursal_aplica_lotes(orden, sucursal, seleccion.orden.Orden_Suc_Factura);

                const response = await Picking_Obtener_Productos_Orden(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, sucursal, orden.Orden_Id);
                if (response.Exitoso) {
                    seleccion.orden.productos = response.Datos;

                    //  El usuario ha seleccionado una sucursal de apoyo. (distinta a la de facturación)
                    if (seleccion.orden.Orden_Suc_Factura != sucursal) {
                        if (Array.isArray(response.Datos)) {
                            if (response.Datos.length > 0) {
                                seleccion.orden.traslado = response.Datos[0].traslado;
                            }
                        }

                        const responseTraslado = await Picking_Obtener_Traslado(this.props.token, this.props.empresa.Id, sucursal, orden.Orden_Id, this.props.callCenter.Id);

                        if (responseTraslado.Exitoso) {
                            seleccion.orden.traslado = responseTraslado.Datos.Mov_Id;
                            seleccion.orden.mov_bodega_id = responseTraslado.Datos.Bodega_Id;
                        } else {
                            Notificacion.error("Ha ocurrido un error al obtener el número de traslado")
                        }
                    } else {
                        seleccion.orden.traslado = null;
                    }

                    seleccion.orden.productos.forEach(producto => {
                        producto.editado = false;
                    })

                    this.setState({ seleccion });
                }
                else {
                    Notificacion.error(response.Mensaje);
                    this.setState({ seleccion });
                }

            }

            this.setState({ cargando: false })
        }
    }

    modificarOrdenSeleccionada = (orden) => {
        let seleccion = Object.assign({}, this.state.seleccion);

        seleccion.orden = orden;

        this.setState({ seleccion });
    }

    reiniciarAccionesModales = () => {
        let modals = Object.assign({}, this.state.modals);

        //  Se reinicia el valor de accionRealizada de los modales de seguridad a su estado inicial = false.
        Object.keys(modals).forEach(key => {
            if ("accionRealizada" in modals[key]) {
                modals[key].accionRealizada = false;
            }
        });
        Object.keys(modals).forEach(key => {
            if ("show" in modals[key]) {
                modals[key].show = false;
            }
        });

        this.setState({ modals })
    }

    seleccionarOrden = async (orden, rangoHoras = null) => {

        let filtro = Object.assign({}, this.state.filtro);

        this.reiniciarAccionesModales();

        let seleccion = Object.assign({}, this.state.seleccion);
        seleccion.orden = orden;
        seleccion.rangoHoras = rangoHoras;

        if (orden) {
            if (this.props.token) {
                let response = await Picking_Obtener_Sucursales_Orden_Seg_Usuario(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, orden.Orden_Id);

                if (response.Exitoso) {
                    filtro.ordenSucursalFactura.options = response.Datos;
                    filtro.ordenSucursalFactura.selected = "none";

                    filtro.ordenSucursalFactura.options.forEach(option => {
                        if (option.Suc_Id == this.props.sucursal.Id) {
                            filtro.ordenSucursalFactura.selected = option.Suc_Id
                        }
                    })
                } else {
                    Notificacion.error(response.Mensaje);
                }

                let pendiente = false;
                pendiente = await Picking_Suborden_Esta_Pendiente(this.props.token, this.props.empresa.Id, filtro.ordenSucursalFactura.selected, this.props.callCenter.Id, orden.Orden_Id);
                seleccion.orden.estatus = (pendiente.Exitoso && pendiente.Datos) ? "pendiente" : "aplicada";

                this.setState({ seleccion, filtro }, () => this.cargarProductosOrden(orden));
            } else {
                return
            }
        } else {
            this.setState({ seleccion }, () => { this.actualizarFiltro({ target: { name: "ordenSucursalFactura", value: "none" } }); this.cargarOrdenes(this.state.fecha_activa) })
        }
    }

    generarTablaProductosOrden = () => {
        let seleccion = Object.assign({}, this.state.seleccion);

        return (
            <>
                <h4 className="mb-3">{(seleccion.orden.traslado && `Traslado #${seleccion.orden.traslado}`)}</h4>
                <Carousel>
                    {
                        seleccion.orden.productos && seleccion.orden?.productos.map((producto, i) => (
                            <Carousel.Item>
                                <div className="picking-orden-item" key={i}>
                                    <div className="row">
                                        <div className="col-4" style={{ alignSelf: "center" }}>
                                            <img className="item-picking-image" src={producto.imagen && producto.imagen.length > 0 && producto.imagen !== "https://dummyimage.com/100x100" ? producto.imagen : ImagenesRutas.ArtDefault} />
                                        </div>
                                        <div className="row col-8">
                                            <div className="etiqueta">
                                                <p className="codigo">{producto.id} {producto.nombre}</p>
                                            </div>
                                            <div>
                                                <p className="cant-picking">Cantidad: {producto.auditado}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
            </>
        )
    }

    pickingModalActionResult = (pUsuario) => {
        if (this.props.token) {
            let promise = Picking_Suborden_Requiere_Traslado(this.props.token, this.props.empresa.Id, this.state.filtro.ordenSucursalFactura.selected, this.props.callCenter.Id, this.state.seleccion.orden.Orden_Id);

            promise.then(response => {
                if (response.Exitoso) {
                    //  La orden requiere traslado
                    if (response.Datos) {
                        this.aplicarPicking(true, pUsuario).then(pickingRes => {
                            //  El picking se aplicó correctamente
                            if (pickingRes) {
                                let trasladoFueAplicado = Picking_Traslado_Fue_Aplicado(this.props.token, this.props.empresa.Id, this.state.filtro.ordenSucursalFactura.selected, this.state.seleccion.orden.traslado)

                                trasladoFueAplicado.then(trasladoFueAplicadoResponse => {
                                    //  El traslado no ha sido efectuado
                                    if (!trasladoFueAplicadoResponse.Datos) {
                                        let modals = Object.assign({}, this.state.modals);
                                        this.setState({ modals: { ...modals, confirmacion: { ...modals.confirmacion, show: true } } })
                                    } else {
                                        Notificacion.success("El traslado ya ha sido aplicado por otro usuario.")
                                    }
                                })
                            }
                        });
                    } else {
                        this.aplicarPicking(true, pUsuario).then(pickingAplicado => {
                            if (pickingAplicado) {
                                //  TODO:   @jrocha Realizar acción cuando se aplica la orden y esta no requiere traslado
                            }
                        });
                    }
                } else {
                    Notificacion.error("Ha ocurrido un error al determinar si la orden requiere traslado.");
                }
            });
        }
    }

    trasladoModalActionResult = (pUsuario) => {
        this.aplicarTraslado(true, pUsuario).then(trasladoAplicado => {
            //  El traslado se aplicó correctamente
            if (trasladoAplicado) {
                //this.seleccionarOrden(null);
                //  TODO:   @jrocha Realizar acción cuando el traslado se aplica correctamente
            }
        })
    }

    /*LOTES*/
    agregar_SubOrden_Detalle_Lotes = async (pSuc_Id, pOrden_Id, pLstLotes) => {
        if (this.props.token) {
            const response = await Agregar_SubOrden_Detalles_Lote_Request(this.props.token, this.props.empresa.Id, pSuc_Id, this.props.callCenter.Id, pOrden_Id, pLstLotes);
            if (!response.Exitoso) {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    eliminar_SubOrden_Detalle_Lotes_Articulo = async (pOrden_Id, pArticulo_Id) => {
        if (this.props.token) {
            const response = await Eliminar_SubOrden_Detalles_Lote_Por_Articulo_Request(this.props.token, this.props.empresa.Id, this.props.sucursal.Id, this.props.callCenter.Id, pOrden_Id, pArticulo_Id);
            if (!response.Exitoso) {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    onClickLotes = (item) => {

        let parametrosLotes = { ...this.state.parametrosLotes };
        parametrosLotes.empresa_id = this.props.empresa.Id;
        parametrosLotes.sucursal_id = item.sucursal;
        parametrosLotes.cantidad_requerida = item.auditado;
        parametrosLotes.bodega_id = item.bodega_id;
        parametrosLotes.cantidad_decimales = this.state.parametrosGenerales ? this.state.parametrosGenerales.Maximo_Decimales_Articulo_Cantidad : 0;

        let articuloLotes = { ...this.state.articuloLotes };
        articuloLotes.Articulo_Id = item.id;
        articuloLotes.Codigo_Principal = item.codigo_principal;
        articuloLotes.Nombre = item.nombre;
        articuloLotes.Articulo_Dias_Vence = item.dias_vence;
        articuloLotes.Articulo_Vence = item.vence;
        articuloLotes.Decimales = item.permiteDecimales;

        let lstLotesSubOrden = [...this.state.lstLotesSubOrden];
        const lstLotesArticulo = lstLotesSubOrden.filter(lote => lote.Articulo_Id === item.id);

        this.setState({ parametrosLotes, articuloLotes, showLotes: true, lstLotesArticulo });
    }

    onCloseLotes = (pLstLotes, pHasChanges) => {
        let lstLotesSubOrden = this.state.lstLotesSubOrden.filter(lote => lote.Articulo_Id !== this.state.articuloLotes.Articulo_Id);
        lstLotesSubOrden = pLstLotes && pLstLotes.length > 0 ? [...lstLotesSubOrden, ...pLstLotes] : lstLotesSubOrden;

        this.setState({ lstLotesSubOrden, showLotes: false });

        if (pLstLotes && pLstLotes.length > 0) {
            pHasChanges && this.agregar_SubOrden_Detalle_Lotes(this.state.filtro.ordenSucursalFactura.selected, this.state.seleccion.orden.Orden_Id, pLstLotes);
        }
        else {
            pHasChanges && this.eliminar_SubOrden_Detalle_Lotes_Articulo(this.state.seleccion.orden.Orden_Id, this.state.articuloLotes.Articulo_Id);
        }

        // Actualizar lista lotes no validos
        let lotes_no_validos = [...this.state.lotes_validar];
        if (lotes_no_validos && lotes_no_validos.length > 0) {

            const indexLote = lotes_no_validos.findIndex(lote => lote.Articulo_Id === this.state.articuloLotes.Articulo_Id);
            if (indexLote > -1) {

                let cantidad_lotes = 0;

                const lotesArticulo = lstLotesSubOrden.filter(lote => lote.Articulo_Id === this.state.articuloLotes.Articulo_Id);
                if (lotesArticulo && lotesArticulo.length > 0) {
                    cantidad_lotes = lotesArticulo.reduce((a, b) => a + (parseFloat(b['Cantidad'] || 0)), 0);
                }

                if (cantidad_lotes !== parseFloat(lotes_no_validos[indexLote].Detalle_Facturar)) {
                    lotes_no_validos[indexLote].Cant_Lotes = cantidad_lotes;
                }
                else {
                    lotes_no_validos.splice(indexLote, 1);
                }

                this.setState({ lotes_validar: lotes_no_validos });
            }
        }
    }

    onCloseModalValidarLotes = () => {
        this.setState({ showModalValidarLotes: false });
    }

    render() {
        const { filtro, ordenes, seleccion, cargando, intervaloRecogerTienda, sucursalAplicaLotes, showModalValidarLotes, lotes_validar, menuOpciones,
            showLotes, conexionLotes, parametrosLotes, articuloLotes, lstLotesArticulo, cantDiasCalendarizados } = this.state;

        const style = { color_primario: '#0b5ed7' };

        return (
            <>
                <div className="picking">
                    <div className="menu3">
                        <Navbar className="row">
                            <div className="col-auto">
                                <Navbar.Brand>Picking</Navbar.Brand>
                            </div>
                            <div className="col text-overflow-ellipsis" style={{ padding: "0px" }}>
                                {
                                    seleccion.orden ?
                                        <div><span onClick={() => { this.seleccionarOrden(null) }} className="link selectable"><FontAwesomeIcon icon={faChevronLeft} /> Orden #{seleccion.orden.Orden_Id}</span></div>
                                        :
                                        <>{this.props.sucursal.Nombre} <span className="spot" /> {seleccion.sucursalApoyo ? seleccion.sucursalApoyo?.Nombre : "Todas las sucursales de apoyo"} </>
                                }
                            </div>
                            {
                                seleccion.orden ?
                                    seleccion.rangoHoras && <div className={"col" + (seleccion.orden ? "" : "-2") + " text-right text-overflow-ellipsis"}><span><FontAwesomeIcon icon={faClock} /> {seleccion.rangoHoras}</span></div>
                                    :
                                    <div className={"col" + (seleccion.orden ? "" : "-2") + " text-right text-overflow-ellipsis"}><FontAwesomeIcon icon={faFilter} className="selectable" onClick={() => { this.alternarFiltro() }} /></div>
                            }
                        </Navbar>
                    </div>
                    {
                        seleccion.orden && seleccion.orden.productos ?
                            Array.isArray(seleccion.orden.productos) ?
                                <PickingDetalle
                                    seleccion={seleccion}
                                    setPrepararOrden={this.setPrepararOrden}
                                    modificarOrdenSeleccionada={this.modificarOrdenSeleccionada}
                                    auditarProducto={this.confirmarAuditarProducto}
                                    filtro={filtro}
                                    toggleModal={this.toggleModal}
                                    actualizarFiltro={this.actualizarFiltro}
                                    cargando={cargando}
                                    sucursalAplicaLotes={sucursalAplicaLotes}
                                    onClickLotes={this.onClickLotes}
                                    cantidadDecimales={this.state.parametrosGenerales ? this.state.parametrosGenerales.Maximo_Decimales_Articulo_Cantidad : 0}
                                    validarArticuloDespacho={this.state.validarArticuloDespacho}
                                />
                                : null
                            : <PickingInt
                                intervaloRecogerTienda={intervaloRecogerTienda}
                                cargando={cargando}
                                filtrarOrdenes={this.cargarOrdenes}
                                seleccionarOrden={this.seleccionarOrden}
                                actualizarFiltro={this.actualizarFiltro}
                                filtro={filtro}
                                ordenes={ordenes}
                                cantDiasCalendarizados={cantDiasCalendarizados} />
                    }
                </div>
                {
                    this.state.modals.picking.show && menuOpciones.filter(opcion => opcion.Nombre === segMenuOpcionesXUsuario[0])[0].Validar ?
                        <ModalSeguridad onHide={() => {
                            let modals = Object.assign({}, this.state.modals);
                            modals.picking.show = false;
                            modals.traslado.show = false;
                            this.setState({ modals });
                        }}
                            modalTitle={this.state.modals.picking.title}
                            okButtonLabel="Aplicar"
                            cancelButtonLabel="Cancelar"
                            show={true}
                            activoAD={this.state.activoAD}
                            menuId={menuOpciones.filter(opcion => opcion.Nombre === segMenuOpcionesXUsuario[0])[0].Menu_Id}
                            opcionId={menuOpciones.filter(opcion => opcion.Nombre === segMenuOpcionesXUsuario[0])[0].Opcion_Id}
                            token={this.props.token}
                            deshabilitarAccion={cargando}
                            onActionResult={
                                (autorizado, usuario) => {
                                    this.toggleModal("picking", false);

                                    if (autorizado) {
                                        this.validar_vencimiento_lotes(usuario);
                                    }
                                }
                            }
                        />
                        : null
                }
                {
                    this.state.modals.traslado.show && menuOpciones.filter(opcion => opcion.Nombre === segMenuOpcionesXUsuario[1])[0].Validar ?
                        <ModalSeguridad onHide={() => {
                            let modals = Object.assign({}, this.state.modals);
                            modals.picking.show = false;
                            modals.traslado.show = false;
                            this.setState({ modals });
                        }}
                            modalTitle={this.state.modals.traslado.title}
                            okButtonLabel="Aplicar"
                            cancelButtonLabel="Cancelar"
                            show={true}
                            activoAD={this.state.activoAD}
                            menuId={menuOpciones.filter(opcion => opcion.Nombre === segMenuOpcionesXUsuario[1])[0].Menu_Id}
                            opcionId={menuOpciones.filter(opcion => opcion.Nombre === segMenuOpcionesXUsuario[1])[0].Opcion_Id}
                            token={this.props.token}
                            deshabilitarAccion={cargando}
                            onActionResult={(autorizado, usuario) => {

                                if (autorizado) {
                                    this.trasladoModalActionResult(usuario);
                                }
                            }}
                        />
                        : null
                }
                {
                    this.state.modals.loteVence.show && menuOpciones.filter(opcion => opcion.Nombre == segMenuOpcionesXUsuario[2])[0].Validar ?
                        <ModalSeguridad onHide={() => {
                            let modals = Object.assign({}, this.state.modals);
                            modals.picking.show = false;
                            modals.traslado.show = false;
                            modals.loteVence.show = false;

                            this.setState({ modals });
                        }}
                            modalTitle={this.state.modals.loteVence.title}
                            okButtonLabel="Aceptar"
                            cancelButtonLabel="Cancelar"
                            show={true}
                            activoAD={this.state.activoAD}
                            menuId={menuOpciones.filter(opcion => opcion.Nombre === segMenuOpcionesXUsuario[2])[0].Menu_Id}
                            opcionId={menuOpciones.filter(opcion => opcion.Nombre === segMenuOpcionesXUsuario[2])[0].Opcion_Id}
                            token={this.props.token}
                            deshabilitarAccion={cargando}
                            onActionResult={(autorizado, usuario) => {
                                this.toggleModal("loteVence", false);
                                if (autorizado) {
                                    this.pickingModalActionResult(usuario);
                                }
                            }}
                        />
                        : null
                }
                {
                    this.state.modals.confirmacion.show ?
                        <Confirmacion show={true} title="Aplicar Traslado"
                            onCancel={(() => {
                                let modals = Object.assign({}, this.state.modals);
                                this.setState({ modals: { ...modals, confirmacion: { ...modals.confirmacion, show: false } } }, () => {
                                    Notificacion.success("Se ha omitido el traslado.");
                                })
                            }).bind(this)}
                            onOk={(() => {
                                let modals = Object.assign({}, this.state.modals);
                                this.setState({ modals: { ...modals, confirmacion: { ...modals.confirmacion, show: false } } }, () => {
                                    this.toggleModal("traslado", true)
                                })
                            }).bind(this)}
                            preContent={(
                                <Fragment>
                                    {this.generarTablaProductosOrden()}
                                    <h4 style={{ textAlign: "center", fontSize: 20 }}>¿Desea aplicar el traslado?</h4>
                                </Fragment>
                            )}
                            cancelButtonLabel="NO"
                            okButtonLabel="SI"
                        />
                        : null
                }

                <ModalValidarLotes show={showModalValidarLotes} rows={lotes_validar} onClickLotes={this.onClickLotes} onClose={this.onCloseModalValidarLotes} />

                <LotesComponent show={showLotes} conexion={conexionLotes} parametros={parametrosLotes} articulo={articuloLotes} lstLotes={lstLotesArticulo} style={style} onClose={this.onCloseLotes} />
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal,
        callCenter: state.parametros.callCenter
    };
};

export default connect(mapStateToProps)(withRouter(memo(Picking)));